import React from 'react'
import './brochure.css'

function BrochurePage() {
  return (
    <main id="brochure-page">
      <section className="hero py-0">
        <iframe src="https://cdn.flipsnack.com/widget/v2/widget.html?hash=z1plttt4ot" width="100%" height="100%" seamless="seamless" allowFullScreen></iframe>
      </section>
    </main>
  )
}

export default BrochurePage